var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fsg-back-cover-promo-area"},[_c('div',{staticClass:"branding-area"},_vm._l((_vm.branding.covers),function(brand,index){return _c('Branding',{key:index,attrs:{"brand":brand}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }